module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-006.33e821c9.png";